import { useState } from "react";
import axios from 'axios'
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { notification, Tooltip } from 'antd';

// import SAISVG from "../../../../../_template/helpers/CommonFunction";
// import { base64Encode, getShortForm } from "../../../../component/common/Helper";

import SAISVG from "../../../../../../_template/helpers/CommonFunction";
import { base64Encode, getShortForm } from "../../../../../component/common/Helper";

const TableRow = (props) => {
    const loginUserType = localStorage.getItem('type');
    const bot_url = process.env.REACT_APP_BOT_URL;
    const api_base_url = process.env.REACT_APP_API_URL;
    const [api, contextHolder] = notification.useNotification();
    const [isActive, setIsActive] = useState(props.row.active_status === "Y" ? true:false);

    let symbolVal = '';
    if(Object.keys(props.row.widget_avatar).length > 0){
        symbolVal = <img src={props.row.widget_avatar.filePath} alt={props.row.widget_name} className="w-85 rounded" />
    }
    else{
        symbolVal = <span className="symbol-label fs-2x fw-bold text-primary text-uppercase">{getShortForm(props.row.widget_name)}</span>
    }

    const handelCheckbox = async(event) => {

        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }


        setIsActive(event.target.checked);
        try {
            const api_params = {};
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            api_params.status = event.target.checked ? "Y" : "N";
            api_params.widget_id = props.row.widget_id;
            api_params.sass_id = localStorage.getItem('sass_id');

            await axios.post(`${api_base_url}admin/active-status-change`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        api["success"]({
                            message: 'Success',
                            description: res.data.message
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    //setIsActive(!event.target.checked);
                }) 
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    }
    const handelDelete = async() => {

        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }


        const widgetDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (widgetDeleteSwal.isConfirmed) {
            const api_params = {};
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            api_params.widget_id = props.row.widget_id;
            api_params.widget_type = props.row.widget_type;
            api_params.sass_id = localStorage.getItem('sass_id');

            await axios.post(`${api_base_url}admin/delete-widget`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        api["success"]({
                            message: 'Success',
                            description: res.data.message
                        });
                        props.deleteSuccess({widget_id: props.row.widget_id});
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }
    const handelEdit = async() => {
        props.editId({widget_id: props.row.widget_id});
    }

    var integrationScript = '';
    if(props.row.widget_type === "E") {
        integrationScript = `<script src="${api_base_url+''+bot_url}" bizcode="${base64Encode(props.row.sass_id)}" id="secured" widget="${base64Encode(props.row.widget_id)}"></script>`;
    } else {
        integrationScript = `<script src="${api_base_url+''+bot_url}" bizcode="${base64Encode(props.row.sass_id)}" auth="${base64Encode(props.row.connected_bot_id)}" id="secured" widget="${base64Encode(props.row.widget_id)}"></script>`;
    }
    const copyHandler = async (param) => {
        await navigator.clipboard.writeText(param);
        toast.success("Script copied successfully");
    };
    return (
        <>
        <tr>
            <td>
                <div className="d-flex align-items-center border-none">
                    <div className="symbol symbol-50px overflow-hidden me-3">
                        <a>
                            <div className="symbol-label fs-3 bg-light-dark text-dark fw-bold text-uppercase">
                                {symbolVal}
                            </div>
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a className="text-gray-800  mb-1">
                            {props.row.widget_name}
                        </a>
                        <div className="d-flex">
                            {props.row.allow_voice == "Y" && <span className="me-2">
                                <div className="badge badge-light-dark fw-bold">Voice</div>
                            </span>}
                            {props.row.allow_attachment == "Y" && <span className="me-2">
                                <div className="badge badge-light-dark fw-bold">Attachment</div>
                            </span>}
                            {props.row.allow_survey == "Y" && <span className="me-2">
                                <div className="badge badge-light-dark fw-bold">Survey</div>
                            </span>}
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <span className="me-2">
                    <Tooltip title="Hook URL">
                        <div className="badge badge-light-primary fw-bold mb-2">{props.row.hook_url}</div>
                    </Tooltip>
                </span>
                <div className="d-flex justify-content-start flex-column">
                    <div className='row'>
                        <div className='col-md-6'>
                            <a className="text-gray-800 fw-bold fs-7">
                                Integration Script
                            </a>
                        </div>
                    </div>
                    <span className="text-gray-600 fw-semibold d-block fs-7 cursor-pointer">
                        <Tooltip title="Click to copy the script" onClick={() => copyHandler(integrationScript)}>{integrationScript}</Tooltip>
                    </span>
                </div>
            </td>
            <td>
                <div className="d-flex mb-4 float-end">
                    <div className="form-check form-switch my-auto me-2">
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            value={isActive} 
                            checked={isActive}
                            onChange={handelCheckbox}
                        />
                    </div>
                    <button className="btn btn-sm btn-icon btn-light-primary me-3 px-4" onClick={handelEdit}>
                        <SAISVG path="media/icons/duotune/art/art005.svg" className="svg-icon-muted svg-icon-2" />
                    </button>
                    {props.row.widget_type == "E" && <button 
                        className="btn btn-sm btn-icon btn-light-danger px-4"
                        onClick={handelDelete}
                    >
                        <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                    </button>}
                </div>
            </td>
        </tr>
        {contextHolder}
        </>
    )
}

export default TableRow;